import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import CaseStudies from './pages/CaseStudies';
import Contact from './pages/Contact';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Careers from './pages/Careers';
import Blog from './pages/Blog';
import Header from './components/Header';

import FinOpsExplained from './pages/blogs/FinOpsExplained';
import SecurityAndEfficiency from './pages/blogs/SecurityAndEfficiency';
import AWSVMwareMigration from './pages/blogs/AWSVMwareMigration';
import AWSRDSDeployment from './pages/blogs/AWSRDSDeployment';
import AIDrivenInsights from './pages/blogs/AIDrivenInsights';

const RoutesComponent = () => (
  <>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/case-studies" element={<CaseStudies />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/blog" element={<Blog />} />

      <Route path="/blog/finops-explained" element={<FinOpsExplained />} />
      <Route path="/blog/security-and-efficiency" element={<SecurityAndEfficiency />} />
      <Route path="/blog/aws-vmware-migration" element={<AWSVMwareMigration />} />
      <Route path="/blog/aws-rds-deployment" element={<AWSRDSDeployment />} />
      <Route path="/blog/ai-driven-insights" element={<AIDrivenInsights />} />
    </Routes>
  </>
);

export default RoutesComponent;
